import React, { useEffect } from "react";
import { CM } from "../../data/forPageContent";
import usePageSeo from "../../hooks/usePageSeo";
import useUtmParams from "../../hooks/useUtmParams";
import StartHeader from "../../components/start/StartHeader";
import StartFooter from "../../components/start/StartFooter";
import StartFeatureRows from "../../components/start/StartFeatureRow";
import StartStats from "../../components/start/StartStats";
import StartTestimonials from "../../components/start/StartTestimonials";
import StartSecurity from "../../components/start/StartSecurity";
import StartFaq from "../../components/start/StartFaq";
import StartClose from "../../components/start/StartClose";
import StartStickyBar from "../../components/start/StartStickyBar";
import ForHero from "../../components/for/ForHero";
import ForProse from "../../components/for/ForProse";
import ForFeatures from "../../components/for/ForFeatures";
import ForProfessions from "../../components/for/ForProfessions";
import useJsonLd from "../../components/for/useJsonLd";
import { buildClinicManagementJsonLd } from "../../components/for/forJsonLd";
import "../../components/start/startReveal.css";
import "../start/StartPage.css";

/** Lead profession stored for this pillar page (PROFESSIONS key with slug clinic-management). */
const PROFESSION_KEY = "multidisciplinary";

/** "A. B" → A in white, B in mint (same rule as StartHero). */
function AccentTitle({ text }) {
  const idx = text.indexOf(". ");
  if (idx === -1) return text;
  return (
    <>
      {text.slice(0, idx + 1)} <em>{text.slice(idx + 2)}</em>
    </>
  );
}

/** /for/clinic-management — head-term pillar page on the /start design. */
function ClinicManagementPage() {
  const utm = useUtmParams();

  usePageSeo({ title: CM.seo.title, description: CM.seo.description, path: CM.seo.path });

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useJsonLd("clinic-management-jsonld", buildClinicManagementJsonLd, []);

  return (
    <div className="st-page" dir="rtl">
      <StartHeader />

      <main className="st-main" data-profession={PROFESSION_KEY}>
        <ForHero
          crumb={CM.seo.breadcrumb}
          overline={CM.hero.overline}
          title={<AccentTitle text={CM.hero.title} />}
          sub={CM.hero.sub}
          profession={PROFESSION_KEY}
          utm={utm}
        />

        <ForProse id="cm-what-is" title={CM.whatIs.title} paragraphs={CM.whatIs.paragraphs} />

        <ForFeatures
          id="cm-features"
          overline={CM.features.overline}
          title={CM.features.title}
          sub={CM.features.sub}
          items={CM.features.items}
        />

        <StartFeatureRows profession={PROFESSION_KEY} />
        <StartStats />
        <StartTestimonials />
        <StartSecurity />
        <ForProfessions
          overline={CM.professions.overline}
          title={CM.professions.title}
          sub={CM.professions.sub}
          currentSlug="clinic-management"
        />
        <StartFaq items={CM.faq} />
        <StartClose profession={PROFESSION_KEY} utm={utm} />
      </main>

      <StartFooter />
      <StartStickyBar />
    </div>
  );
}

export default ClinicManagementPage;
